import React from 'react'
import { type LucideProps } from 'lucide-react'

const Bridge: React.FC<LucideProps> = (props: LucideProps) => (
<svg
  width={23}
  height={23}
  viewBox="0 0 23 23"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <circle
    cx="21.3054"
    cy="11.7233"
    r="0.493842"
    stroke="#949494"
    strokeWidth="0.75"
  />
  <circle
    cx="20.7715"
    cy="11.7233"
    r="1.75104"
    stroke="#949494"
    strokeWidth="0.75"
  />
  <circle
    cx="19.2692"
    cy="11.7233"
    r="3.25307"
    stroke="#949494"
    strokeWidth="0.75"
  />
  <circle
    cx="17.6937"
    cy="11.5427"
    r="4.82851"
    stroke="#949494"
    strokeWidth="0.75"
  />
  <circle
    cx="16.073"
    cy="11.5427"
    r="6.44947"
    stroke="#949494"
    strokeWidth="0.75"
  />
  <circle
    cx="14.042"
    cy="11.5427"
    r="8.48044"
    stroke="#949494"
    strokeWidth="0.75"
  />
  <circle
    cx="11.561"
    cy="11.5427"
    r="10.9614"
    stroke="#949494"
    strokeWidth="0.75"
  />
</svg>



)

export default Bridge
